'use strict';

var pendingModalRequests = {};

/**
 * Loads a remote PDP modal into its placeholder container only when needed.
 *
 * @param {jQuery} $trigger - The clicked trigger element.
 * @returns {Promise<jQuery>} Resolves with the requested modal element.
 */
function ensureRemoteModal($trigger) {
    var url = $trigger.data('modal-url');
    var modalSelector = $trigger.data('modal-selector');
    var containerSelector = $trigger.data('modal-container');
    var requestKey = containerSelector || modalSelector || url;
    var $container = containerSelector ? $(containerSelector) : $();
    var $modal = modalSelector ? $(modalSelector).first() : $();

    if ($modal.length && $container.attr('data-loaded-url') === url) {
        return Promise.resolve($modal);
    }

    if (pendingModalRequests[requestKey]) {
        return pendingModalRequests[requestKey];
    }

    pendingModalRequests[requestKey] = new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'html',
            success: function (html) {
                if ($container.length) {
                    $container.html(html);
                    $container.attr('data-loaded-url', url);
                } else {
                    $('body').append(html);
                }

                delete pendingModalRequests[requestKey];
                resolve($(modalSelector).first());
            },
            error: function (xhr, statusText, errorThrown) {
                delete pendingModalRequests[requestKey];
                reject(new Error(errorThrown || statusText || 'Unable to load modal.'));
            }
        });
    });

    return pendingModalRequests[requestKey];
}

module.exports = function () {
    $('body').on('click', '.js-pdp-remote-modal-trigger', function (event) {
        var $trigger = $(this);
        var modalSelector = $trigger.data('modal-selector');

        if (!modalSelector) {
            return;
        }

        event.preventDefault();

        ensureRemoteModal($trigger).then(function ($modal) {
            if ($modal.length) {
                $modal.modal('show');
            }
        }).catch(function () {
            // Fail silently and keep the page interactive if the remote modal cannot be fetched.
        });
    });
};
